import React, {ReactNode, useContext} from 'react'
import { isNativeWebviewVersion2 } from '../../helpers/reactNativeWebview'
import { useIsSsr } from '../hocs/hooks'
import styles from './Breadcrumb.scss'
import { StaticStateContext } from './Context'

const Breadcrumb = ({ children }: {
  children: ReactNode
}) => {
  const isWebview = useContext(StaticStateContext)!.isWebview || !useIsSsr() && isNativeWebviewVersion2()
  return !isWebview
    ? <nav aria-label="breadcrumb d-inline" className={styles.breadcrumbHeight}>
        <ol className={['breadcrumb px-0', styles.breadcrumbBack].join(' ')}>
          <div className="container">
            {(Array.isArray(children) ? children : [children]).filter(Boolean).map((elm, index, arr) => {
              const isLast = index === arr.length - 1
              // @ts-ignore
              return <li
                key={index}
                className={['breadcrumb-item d-inline', isLast && 'active' && styles.activeFont].filter(Boolean).join(' ')}
                aria-current={isLast ? 'page' : undefined}>
                {elm}
              </li>
            }
            )}
          </div>
        </ol>
      </nav>
    : <></>
}
Breadcrumb.displayName = 'Breadcrumb'
export default Breadcrumb
